import { mapState } from 'vuex'
import RepairPageHelpersMixin from '@/components/repair/RepairPageHelpersMixin'

export default {
  mixins: [RepairPageHelpersMixin],
  data() {
    return {
      rootPageTitle: this.$t('title.repairService'),
    }
  },
  computed: {
    ...mapState(['repair']),
    categories() {
      return this.repair.categories
    },
    services() {
      return this.repair.services
    },
    isRootService() {
      const { subcategory, category, service } = this.$route.params
      return !category && !subcategory && !service
    },
    isCategory() {
      const { subcategory, category, service } = this.$route.params
      return category && !subcategory && !service
    },
    isSubcategoryService() {
      const { subcategory, category, service } = this.$route.params
      return category && subcategory && service
    },
    isSubcategory() {
      const { subcategory, category, service } = this.$route.params
      return category && subcategory && !service
    },
    categoryInfo() {
      return (this.repair.categories || []).find(
        ({ slug }) => slug === this.$route.params.category
      )
    },
    subcategoryInfo() {
      return (this.categoryInfo?.subData || []).find(
        ({ slug }) => this.$route.params.subcategory === slug
      )
    },
    serviceInfo() {
      if (this.isSubcategory) {
        return (this.repair.services || []).find(
          ({ slug, category }) =>
            slug === this.$route.params.subcategory &&
            category === this.categoryInfo?.name
        )
      }
      return (this.repair.services || []).find(
        ({ slug, subcategory, category }) =>
          slug === this.$route.params.service &&
          subcategory === this.subcategoryInfo?.name &&
          category === this.categoryInfo?.name
      )
    },
    servicesSlugs() {
      return (this.repair.services || []).map(({ slug }) => slug)
    },
  },
}
